import { useTranslation } from 'react-i18next';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import InfoSections from './components/InfoSections';
import ArticleSection from './components/ArticleSection';
import FaqSection from './components/FaqSection';
import JsonLd from '@/components/base/JsonLd';
import { websiteSchema, organizationSchema, faqPageSchema } from '@/data/schema';

interface FaqItem {
  q: string;
  a: string;
}

export default function Home() {
  const { t } = useTranslation();

  const faqItems = t('home.faq.items', { returnObjects: true }) as unknown as FaqItem[];

  return (
    <>
      <JsonLd data={websiteSchema()} />
      <JsonLd data={organizationSchema()} />
      <JsonLd data={faqPageSchema(faqItems)} />
      <Hero />
      <CategorySection />
      <InfoSections />
      <ArticleSection />
      <FaqSection />
    </>
  );
}